import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import SummaryCard from '@intelligence/components/SummaryCard';
import { getSteamOverlapGameSummaryDatas } from '@intelligence/services/overlapAnalysis';
import {
  OVERLAP_STEAM_SUMMARY_METRIC,
  SUMMARY_METRIC_LIST,
} from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/OverlapSteam/constants/metrics';
import { useIntl } from 'umi';
import { StudioContext } from '@home/pages/studio/context';
import { LANGUAGE_EN } from '@home/_config/config';
import classNames from 'classnames';
import { formatPercentNumX } from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/OverlapSteam/utils';
import './index.scss';

const SummaryService = (props: any) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const requestIdRef = useRef(0);
  // 当前游戏信息
  const { currentGame } = useContext(StudioContext);
  const { game_name: gameName } = currentGame || {};

  const { filterVal, className, style, gameInfoLoading, segmentKey = 'played_play', onSummaryLoadingChange } = props || {};
  const { locale } = useIntl();

  // 上报 loading 状态给父组件，用于筛选器防频繁切换
  useEffect(() => {
    onSummaryLoadingChange?.(loading);
  }, [loading]);

  const isEN = locale === LANGUAGE_EN;

  const params = {
    ...filterVal,
    metrics: OVERLAP_STEAM_SUMMARY_METRIC[segmentKey],
    page_size: 5
  };

  const getData = () => {
    const currentRequestId = requestIdRef.current + 1;
    requestIdRef.current = currentRequestId;
    setLoading(true);
    // 添加接口的错参数兜底
    if (params?.engagement_level_a && params?.engagement_level_b) {
      getSteamOverlapGameSummaryDatas({
        ...params,
      })
        .then((data) => {
          if (currentRequestId !== requestIdRef.current) return;
          setData(data?.data || []);
        })
        .catch((err) => {
          if (currentRequestId !== requestIdRef.current) return;
          console.log('🚀 ~ SummaryService ~ err:', err);
        })
        .finally(() => {
          if (currentRequestId === requestIdRef.current) {
            setLoading(false);
          }
        });
    } else if (currentRequestId === requestIdRef.current) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (gameInfoLoading) return;
    getData();
  }, [filterVal, gameInfoLoading]);

  const summaryData = useMemo(() => {
    const metricList = SUMMARY_METRIC_LIST[segmentKey] || [];
    const metricsSummaryList: any = [];
    // const list = [...tableData];
    if (Array.isArray(data) && data?.length > 0) {
      metricList?.forEach((metricSummaryObj: any) => {
        const list = [...data];
        const metricRankObj: any =
          list?.find((metricObj: any) => metricObj?.metric === metricSummaryObj.metricValue) || {};
        const rankList = metricRankObj.rank_list || [];
        if (Array.isArray(rankList) && rankList?.length > 0) {
          // 获取指标前5游戏
          // let topFive = [...list.slice(0, 5)];
          let topFiveNames = '';
          let topFiveValues = '';
          if (Array.isArray(rankList) && rankList?.length > 0) {
            // 取top5游戏的游戏名称
            topFiveNames = rankList?.map((item: any) => item.name)?.join(', ');
            // 取top5游戏的对应指标数值
            topFiveValues = rankList
              ?.map((item: any) => `${formatPercentNumX(item.value, false) || ''}`)
              ?.join(', ');
          }
          const summaryObj = [
            {
              type: 'normal',
              strKey: metricSummaryObj.textFrontKey,
            },
            {
              type: 'black',
              strKey: gameName,
            },
            {
              type: 'normal',
              strKey: metricSummaryObj.textMiddleKey,
            },
            {
              type: 'yellow',
              strKey: topFiveNames,
            },
            {
              type: 'normal',
              strKey: metricSummaryObj.textAfterKey,
            },
            {
              type: 'yellow',
              strKey: topFiveValues,
            },
            {
              type: 'normal',
              strKey: metricSummaryObj.textEndKey,
            },
          ];
          metricsSummaryList.push(summaryObj);
        }
      });
    }
    return metricsSummaryList;
  }, [data, isEN, filterVal]);

  return (
    <div className={classNames('dbh-potential-market-summary', className)} style={style}>
      <SummaryCard strList={summaryData} loading={loading} />
    </div>
  );
};

export default SummaryService;
